<template>
  <div class="m-activity-prizesDeployTimeSet">
    <Dialog :maskClose="false" :dialogShow="show" title="设置投放时间" @maskClick="close" width="650">
      <template>
        <div class="apply">
          <el-form class="list-box" ref="deploytimeset" :model="form" hide-required-asterisk label-width="90px">
            <el-form-item
              v-for="(item, index) in form.dates"
              :label="'投放时间' + (index + 1)"
              :key="item.key"
              :prop="'dates.' + index + '.value'"
              :rules="{ validator: (r, v, c) => checkDate(r, v, c, index) }"
            >
              <el-date-picker
                type="datetimerange"
                range-separator=""
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="timestamp"
                :default-time="['00:00:00', '23:59:59']"
                v-model="item.value"
              />
              <el-button v-if="form.dates.length > 1" @click="onRemoveItem(index)" type="text" class="ml10 del">删除</el-button>
              <span v-else style="width: 28px; margin-left: 10px; display: inline-block;"></span>
              <el-button v-if="form.dates.length == index + 1" @click="onAddItem" type="text" class="ml10">增加</el-button>
            </el-form-item>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="close">取消</el-button>
              <el-button type="primary" class="determine" @click="comfirm">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog/index";

export default {
  name: "marketActivityListPrizesDeployTimeSet",
  components: {
    Dialog
  },
  props: {
    show: Boolean,
    row: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    // 校验日期时间
    const checkDate = (rule, value, callback, index) => {
      let isCross = '' // 是否与其他时间交叉
      if (value) {
        this.form.dates.forEach((item, ind) => {
          if (!isCross && item.value && (index !== ind)) {
            if ((value[0] >= item.value[0] && value[0] <= item.value[1]) || (value[1] >= item.value[0] && value[1] <= item.value[1])) {
              isCross = '与 投放时间' + (ind + 1) + ' 有重叠，请重新选择'
            }
          }
        })
      }

      if (!value || !value.length) {
        callback(new Error('请选择投放时间'))
      } else if (isCross) {
        callback(new Error(isCross))
      } else {
        callback()
      }
    }

    return {
      form: {
        dates: [
          {value: null}
        ]
      },
      checkDate
    };
  },
  created() {
  },
  methods: {
    // 设置渲染数据
    setRenderData() {
      if (this.row && this.row.deployTimeList) {
        let currentData = this.row.deployTimeList.map(item => {
          return {
            value: [item.start, item.end]
          }
        })
        this.form.dates = currentData
      } else {
        this.form = {
          dates: [{value: null}]
        }
      }
    },

    // 增加
    onAddItem() {
      this.form.dates.push({value: null})
    },

    // 删除
    onRemoveItem(index) {
      this.form.dates.splice(index, 1)
    },

    // 确定
    comfirm() {
      this.$refs.deploytimeset.validate(async (valid) => {
        if (valid) {
          let result = this.form.dates.map(item => {
            return {
              start: item.value[0],
              end: item.value[1]
            }
          })
          this.$emit('confirm', result)
        }
      })
    },

    // 关闭弹窗
    close() {
      this.form = {}
      this.$emit('close')
    }
  },
  watch: {
    show: function(value) {
      if (value) {
        this.setRenderData() // 设置渲染数据
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.m-activity-prizesDeployTimeSet {
  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .list-box {
    min-height: 150px;
    max-height: 50vh;
    overflow-y: scroll;
    padding: 20px 0;

    .del {
      color: #F74A4A;
    }

  }

  .button-div {
    padding-top: 20px;
    .button-div-row {
      text-align: right;
    }
  }

}
</style>
